import { Box, Stack } from '@mui/material'
import { alpha } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

/**
 * @param {{ title: string, titleIcon?: import('react').ReactNode, intro?: readonly [string, string], children: import('react').ReactNode }} props
 */
export function PlanUsageCardShellFrame({ title, titleIcon, intro, children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', p: '4px', bgcolor: 'background.default', borderRadius: '24px', boxSizing: 'border-box' }}>
      <Stack spacing={0.5} sx={{ width: '100%', minWidth: 0 }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', py: '2px', px: '4px', gap: 0.75, borderRadius: '6px' }}>
          {titleIcon ? (
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: 'text.secondary', '& svg': { width: 18, height: 18, display: 'block' } }} aria-hidden>
              {titleIcon}
            </Box>
          ) : null}
          {intro ? null : (
            <Typography component="h2" variant="subtitle2" sx={{ fontSize: '0.75rem', fontWeight: 700, lineHeight: '24px', color: 'text.primary' }}>
              {title}
            </Typography>
          )}
        </Box>
        <Box sx={(theme) => ({ display: 'flex', flexDirection: 'column', alignItems: 'stretch', p: '12px', borderRadius: '18px', bgcolor: alpha(theme.palette.background.paper, 0.8), boxSizing: 'border-box', minWidth: 0 })}>
          {children}
        </Box>
      </Stack>
    </Box>
  )
}
